import React, { useMemo, useState } from 'react';
import { addDays, format } from 'date-fns';
import { CheckCircle2Icon, InfoIcon, PhoneIcon } from 'lucide-react';
import { business, services } from '../data/site';
import { FormPolicyLinks } from './FormPolicyLinks';
const timeSlots = ['8:00 AM', '8:30 AM', '9:00 AM', '9:30 AM', '10:00 AM', '10:30 AM', '11:00 AM', '11:30 AM', '1:00 PM', '1:30 PM', '2:00 PM', '2:30 PM', '3:00 PM', '3:30 PM', '4:00 PM'];

// Slots already requested by other customers close out until the team confirms.
const closedSlots = ['9:00 AM', '10:30 AM', '2:00 PM'];
export function AppointmentRequest() {
  const earliest = useMemo(() => addDays(new Date(), 2), []);
  const dateOptions = useMemo(() => Array.from({
    length: 10
  }, (_, i) => addDays(earliest, i)).filter(d => d.getDay() !== 0 && d.getDay() !== 6), [earliest]);
  const [date, setDate] = useState(format(dateOptions[0], 'yyyy-MM-dd'));
  const [slot, setSlot] = useState<string | null>(null);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <section id="request" className="w-full bg-ink py-20 text-white lg:py-28" data-id="element-77" data-mp="33n0h3omfm4rq">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-78" data-mp="33p4t6tuhia33">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)] lg:gap-16" data-id="element-79" data-mp="37p596ix8etc9">
          <div data-id="element-80" data-mp="3cmnkgfyq1knf">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-light" data-id="element-81" data-mp="3cn6rv2qqwqn7">
              Two ways to get on the schedule
            </p>
            <h2 className="mt-4 font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] sm:text-[42px]" data-id="element-82" data-mp="3mcqemjhkx4nc">
              Fastest answer? Call the shop.
            </h2>
            <p className="mt-5 text-[16.5px] leading-relaxed text-chalk/70" data-id="element-83" data-mp="3ve82io18aaml">
              The East End Team answers the phone during business hours and can
              tell you right away what your vehicle likely needs and when we
              can get it in.
            </p>

            <a href={business.phoneHref} className="mt-7 inline-flex w-full items-center justify-center gap-3 whitespace-nowrap rounded-md bg-brand px-7 py-4 font-display text-lg font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:w-auto" data-id="element-84" data-mp="208fcdiegm0ax">
              <PhoneIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-85" data-mp="2jyirfcau48h5" />
              Call {business.phone}
            </a>

            <dl className="mt-9 space-y-3 border-t border-white/10 pt-7 text-[15px]" data-id="element-86" data-mp="2f0hbh08pgp9w">
              <div className="flex justify-between gap-6" data-id="element-87" data-mp="2szz1fixqm8ku">
                <dt className="text-chalk/55" data-id="element-88" data-mp="2sxcspfz41n11">Shop hours</dt>
                <dd className="text-right font-medium" data-id="element-89" data-mp="2o1nsrbj6i447">
                  Mon – Fri, 8:00 AM – 5:00 PM
                </dd>
              </div>
              <div className="flex justify-between gap-6" data-id="element-90" data-mp="yn96qyzjovce">
                <dt className="text-chalk/55" data-id="element-91" data-mp="tnmt4oft1d32">Text the shop</dt>
                <dd className="text-right font-medium" data-id="element-92" data-mp="3596k7dh5uads">
                  <a href={business.smsHref} className="hover:text-brand-light" data-id="element-93" data-mp="35agj24vu7mlh">
                    {business.phone}
                  </a>
                </dd>
              </div>
              <div className="flex justify-between gap-6" data-id="element-94" data-mp="2wglcqtizbq49">
                <dt className="text-chalk/55" data-id="element-95" data-mp="30iq4fmpvaco9">Email</dt>
                <dd className="break-all text-right font-medium" data-id="element-96" data-mp="30h5ekaehzhwq">
                  <a href={`mailto:${business.email}`} className="hover:text-brand-light" data-id="element-97" data-mp="2mi5m0rnv6iva">
                    {business.email}
                  </a>
                </dd>
              </div>
            </dl>
          </div>

          <div className="rounded-xl border border-white/10 bg-charcoal p-6 sm:p-8 lg:p-10" data-id="element-98" data-mp="2hjkncwo9g78y">
            {submitted ? <div className="flex min-h-[420px] flex-col items-start justify-center" data-id="element-99" data-mp="bs72ujngji49">
                <CheckCircle2Icon className="h-10 w-10 text-brand-light" aria-hidden="true" data-id="element-100" data-mp="ft0qdbwzmuwm" />
                <h3 className="mt-5 font-display text-2xl font-bold tracking-tight" data-id="element-101" data-mp="3n5ejqvv770su">
                  Preview only
                </h3>
                <p className="mt-3 max-w-[440px] text-[15.5px] leading-relaxed text-chalk/70" data-id="element-102" data-mp="3d8s0ucmfmjtg">
                  Your request has not been sent. Please call the shop at
                  {' '}{business.phone} to request an appointment.
                </p>
                <button type="button" onClick={() => setSubmitted(false)} className="mt-7 rounded-md border border-white/20 px-5 py-3 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-white/60" data-id="element-103" data-mp="34aptzgg0owy9">
                  Back to the form
                </button>
              </div> : <form onSubmit={handleSubmit} noValidate={false} data-id="element-104" data-mp="2kmqi229pvjr9">
                <h3 className="font-display text-[26px] font-bold tracking-tight" data-id="element-105" data-mp="2gk3mbq9xdeos">
                  Request an appointment
                </h3>
                <p className="mt-2 flex items-start gap-2 text-[14px] leading-relaxed text-chalk/60" data-id="element-106" data-mp="w3cjfoa35zov">
                  <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-light" aria-hidden="true" data-id="element-107" data-mp="104g0ge3ve1ro" />
                  This is a request, not a confirmed booking. Please request at
                  least 1–2 days ahead — we will follow up to confirm.
                </p>

                <div className="mt-7 grid gap-5 sm:grid-cols-2" data-id="element-108" data-mp="hbkdg2w6lxzt">
                  <Field label="Full name" htmlFor="name" data-id="element-109" data-mp="h9r6snlkjdrt">
                    <input id="name" name="name" required autoComplete="name" className={inputClass} data-id="element-110" data-mp="maezddpg42o5" />
                  </Field>
                  <Field label="Phone number" htmlFor="phone" data-id="element-111" data-mp="3uqql3eof32p9">
                    <input id="phone" name="phone" type="tel" required autoComplete="tel" className={inputClass} data-id="element-112" data-mp="3uoxajoaonybz" />
                  </Field>
                  <Field label="Email" htmlFor="email" data-id="element-113" data-mp="9y53ehqeejj">
                    <input id="email" name="email" type="email" required autoComplete="email" className={inputClass} data-id="element-114" data-mp="3rgr4qdwvm5ly" />
                  </Field>
                  <Field label="Year, make & model" htmlFor="vehicle" data-id="element-115" data-mp="3dq5n0sj5s1pn">
                    <input id="vehicle" name="vehicle" className={inputClass} data-id="element-116" data-mp="38qj72bby47d5" />
                  </Field>
                  <Field label="What do you need?" htmlFor="service" className="sm:col-span-2" data-id="element-117" data-mp="szet7zybj99y">
                    <select id="service" name="service" className={inputClass} data-id="element-118" data-mp="o2emdmtna2hs">
                      <option data-id="element-119" data-mp="25wdrr91emy9u">Not sure — please diagnose</option>
                      {services.map(s => <option key={s.name} data-id="element-120" data-mp="2aybdqb16w76h">{s.name}</option>)}
                    </select>
                  </Field>
                  <Field label="Preferred date" htmlFor="date" className="sm:col-span-2" data-id="element-121" data-mp="21w2a854c9e2l">
                    <select id="date" name="date" value={date} onChange={e => {
                  setDate(e.target.value);
                  setSlot(null);
                }} className={inputClass} data-id="element-122" data-mp="2poabicou1glf">
                      {dateOptions.map(d => <option key={d.toISOString()} value={format(d, 'yyyy-MM-dd')} data-id="element-123" data-mp="38ixpbzqtuon3">
                          {format(d, 'EEEE, MMMM d')}
                        </option>)}
                    </select>
                  </Field>
                </div>

                <fieldset className="mt-7" data-id="element-124" data-mp="13khid8th4kyc">
                  <legend className="text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/55" data-id="element-125" data-mp="13hd8pvx8ox0a">
                    Preferred drop-off time
                  </legend>
                  <div className="mt-3 grid grid-cols-3 gap-2 sm:grid-cols-5" data-id="element-126" data-mp="1w7liazdpm939">
                    {timeSlots.map(time => {
                  const closed = closedSlots.includes(time);
                  const selected = slot === time;
                  return <button key={time} type="button" disabled={closed} aria-pressed={selected} onClick={() => setSlot(time)} className={`rounded-md border px-2 py-2.5 text-[13px] font-semibold transition-colors duration-150 ease-out ${closed ? 'cursor-not-allowed border-white/5 bg-white/[0.03] text-chalk/25 line-through' : selected ? 'border-brand bg-brand text-white' : 'border-white/15 text-chalk/80 hover:border-brand-light hover:text-white'}`} data-id="element-127" data-mp="1i7aq9t0nyogi">
                          {time}
                        </button>;
                })}
                  </div>
                  <p className="mt-3 text-[13px] text-chalk/45" data-id="element-128" data-mp="3a5vqd62ml42l">
                    Drop-offs 8:00 AM – 4:00 PM. Closed for lunch 12:00 –
                    1:00 PM. Requested slots close out until confirmed.
                  </p>
                </fieldset>

                <button type="submit" className="mt-4 w-full rounded-md bg-white px-6 py-4 font-display text-base font-bold text-ink transition-colors duration-150 ease-out hover:bg-chalk" data-id="element-129" data-mp="1ktjsf80l3ecv">
                  Send appointment request
                </button>
                <FormPolicyLinks data-id="element-130" data-mp="h52dzra5rqz" />
              </form>}
          </div>
        </div>
      </div>
    </section>;
}
const inputClass = 'w-full rounded-md border border-white/15 bg-ink px-3.5 py-3 text-[15px] text-white placeholder:text-chalk/35 outline-none transition-colors duration-150 ease-out focus:border-brand-light';
function Field({
  label,
  htmlFor,
  className = '',
  children
}: {
  label: string;
  htmlFor: string;
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={className} data-id="element-131" data-mp="o7ix5y1924p9">
      <label htmlFor={htmlFor} className="mb-1.5 block text-[13px] font-semibold uppercase tracking-[0.08em] text-chalk/55" data-id="element-132" data-mp="t7naxgarwlbs">
        {label}
      </label>
      {children}
    </div>;
}